import { useLanguage } from "../context/LanguageContext";

/**
 * Məxfilik Siyasəti.
 *
 * Mətn hüquqi sənəddir — sahibkar tərəfindən təqdim olunub və olduğu kimi
 * saxlanılır. Tərcümə edilmir: hüquqi mətnin maşın tərcüməsi məsuliyyət
 * yaradır. İngilis versiyası lazım olsa, hüquqşünas tərcüməsi əlavə edilməlidir.
 */

const P = ({ children }) => (
  <p className="text-brand-sub font-light leading-relaxed mb-5">{children}</p>
);

const Privacy = () => {
  const { lang } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 sm:py-24" data-testid="privacy-page">
      <p className="overline mb-4">Sparkle</p>
      <h1 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mb-4">
        Məxfilik Siyasəti
      </h1>

      {lang === "en" && (
        <p className="text-xs text-brand-muted border border-brand-line px-4 py-3 mb-10">
          This Privacy Policy is published in Azerbaijani, the official language
          of the Republic of Azerbaijan.
        </p>
      )}

      <div className="border-t border-brand-line pt-10 text-[15px]">
        <P>
          Bu sənəddə (bundan sonra “Sənəd”) qeyd olunan şərtlər{" "}
          <a href="https://www.sparkle.az" className="text-brand-ink underline underline-offset-4">
            www.sparkle.az
          </a>{" "}
          internet saytı (bundan sonra "Biz", "Sparkle" və ya "Veb-sayt") ilə Veb-saytın
          istifadəçisi (bundan sonra "İstifadəçi") arasında mübadilə olunan məlumatların
          konfidensiallığının təmin edilməsini tənzimləyir.
        </P>
        <P>
          Bu Sənəddə "Sparkle" dedikdə, www.sparkle.az internet saytının sahibi nəzərdə tutulur.
        </P>
        <P>
          Bu Sənəddə "İstifadəçi" dedikdə, Veb-sayta həm qeydiyyatdan keçmiş istifadəçi,
          həm də qeydiyyatdan keçmədən ziyarətçi kimi daxil olan bütün fiziki şəxslər
          nəzərdə tutulur.
        </P>
        <P>
          Biz, Veb-saytdan istifadə etdiyiniz zaman təqdim etdiyiniz məlumatların hansı
          qaydada toplandığını, istifadə edildiyini, saxlanıldığını və mühafizə olunduğunu
          aydın şəkildə izah etmək məqsədilə bu Konfidensiallıq Siyasətini hazırlamışıq.
          Məqsədimiz İstifadəçilərin Veb-saytdan təhlükəsiz istifadə etməsini təmin etmək
          və onların təqdim etdikləri fərdi məlumatların qanunvericiliyə uyğun şəkildə
          qorunduğuna əmin olmalarını təmin etməkdir.
        </P>
        <P>
          Veb-saytdan istifadə etməzdən əvvəl bu Konfidensiallıq Siyasəti ilə tanış
          olmağınızı tövsiyə edirik.
        </P>
        <P>
          Bu Konfidensiallıq Siyasəti Azərbaycan Respublikasının Konstitusiyasına,
          Azərbaycan Respublikasının tərəfdar çıxdığı beynəlxalq müqavilələrə, "Fərdi
          məlumatlar haqqında" Azərbaycan Respublikası Qanununa, "İnformasiya əldə etmək
          haqqında" Azərbaycan Respublikası Qanununa və digər tətbiq olunan normativ
          hüquqi aktlara uyğun hazırlanmışdır.
        </P>
        <P>
          Veb-saytda İstifadəçi ilə Sparkle arasında fərdi məlumatların emalı qanunçuluq,
          konfidensiallıq, dürüstlük və könüllülük prinsiplərinə əsasən həyata keçirilir.
        </P>
        <P>
          İstifadəçiyə aid fərdi məlumatlar yalnız onun könüllü şəkildə təqdim etdiyi
          andan etibarən emal edilir və qanunvericiliyin tələblərinə uyğun şəkildə qorunur.
        </P>

        <p className="text-brand-sub font-light leading-relaxed mb-4">
          İstifadəçi tərəfindən təqdim edilən məlumatlara aşağıdakılar daxil ola bilər:
        </p>
        <ul className="mb-8 space-y-2">
          {[
            "adı, soyadı və atasının adı;",
            "doğum tarixi;",
            "cinsi;",
            "telefon nömrəsi;",
            "elektron poçt ünvanı;",
            "çatdırılma və ya yaşayış ünvanı;",
            "sifariş məlumatları;",
            "digər könüllü şəkildə təqdim olunan məlumatlar.",
          ].map((item) => (
            <li key={item} className="flex gap-3 text-brand-sub font-light">
              <span className="text-brand-muted mt-[3px]">—</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <P>
          Bu məlumatlar "Fərdi məlumatlar haqqında" Azərbaycan Respublikası Qanununun
          tələblərinə uyğun olaraq qorunur və İstifadəçinin yazılı razılığı olmadan,
          qanunvericilikdə nəzərdə tutulmuş hallar istisna olmaqla, üçüncü şəxslərə
          təqdim edilmir.
        </P>

        <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight mt-12 mb-6">
          Ödəniş kartı məlumatlarının emalı
        </h2>
        <P>
          Sparkle istifadəçilərin ödəniş kartı məlumatlarının təhlükəsizliyinə xüsusi önəm
          verir. Bu səbəbdən İstifadəçinin bank kartına aid məlumatlar (kart nömrəsi, son
          istifadə tarixi, CVV/CVC təhlükəsizlik kodu və digər kart rekvizitləri) Sparkle
          tərəfindən toplanılmır, emal edilmir və serverlərində saxlanılmır.
        </P>
        <P>
          Veb-sayt vasitəsilə həyata keçirilən bütün kart ödənişləri e-point elektron
          ödəniş sistemi vasitəsilə emal olunur. Kart məlumatları birbaşa e-point-in
          təhlükəsiz ödəniş infrastrukturunda daxil edilir və həmin məlumatların
          saxlanılması yalnız e-point tərəfindən, tətbiq olunan təhlükəsizlik standartlarına
          və qüvvədə olan qanunvericiliyin tələblərinə uyğun qaydada həyata keçirilir.
        </P>
        <P>
          İstifadəçinin razılığı ilə gələcək ödənişlərin daha rahat həyata keçirilməsi
          məqsədilə e-point tərəfindən kartı identifikasiya edən unikal token yaradılır.
          Sparkle yalnız həmin tokeni öz sistemində saxlayır. Sonrakı ödənişlər zamanı kart
          məlumatlarından deyil, həmin token vasitəsilə e-point sisteminə göndərilən sorğu
          əsasında ödəniş həyata keçirilir.
        </P>
        <P>
          Beləliklə, Sparkle heç bir mərhələdə İstifadəçinin tam bank kartı məlumatlarına
          çıxış əldə etmir, onları öz serverlərində saxlamır və emal etmir.
        </P>

        <div className="border-t border-brand-line mt-12 pt-10">
          <P>
            Azərbaycan Respublikasının qanunvericiliyində nəzərdə tutulmuş hallarda,
            hüquq-mühafizə və məhkəmə orqanlarının qanuni və əsaslandırılmış sorğusu
            əsasında İstifadəçinin razılığı alınmadan müvafiq məlumatlar həmin orqanlara
            təqdim edilə bilər.
          </P>
          <P>
            Veb-saytda digər internet resurslarına keçidlər yerləşdirilə bilər. Həmin
            internet resurslarında təqdim etdiyiniz məlumatların emalı və qorunmasına
            Sparkle cavabdeh deyildir. Belə internet resurslarının konfidensiallıq siyasəti
            ilə ayrıca tanış olmağınızı tövsiyə edirik.
          </P>
          <P>
            İstifadəçi istənilən vaxt fərdi məlumatlarını təqdim etməmək hüququna malikdir.
            Lakin bəzi xidmətlərdən, o cümlədən qeydiyyatın tamamlanması, sifarişlərin
            rəsmiləşdirilməsi, ödənişlərin həyata keçirilməsi, şəxsi kabinetdən istifadə və
            digər funksiyalardan yararlanmaq üçün müəyyən məlumatların təqdim edilməsi
            zəruri ola bilər. Belə məlumatlar təqdim edilmədiyi halda, Veb-saytın bəzi
            imkanlarından istifadə mümkün olmaya bilər.
          </P>
          <P>
            Sparkle qanunvericilikdə baş verən dəyişikliklər, xidmətlərin təkmilləşdirilməsi
            və ya digər zəruri səbəblərlə əlaqədar bu Konfidensiallıq Siyasətinə birtərəfli
            qaydada dəyişiklik etmək hüququnu özündə saxlayır. Yenilənmiş Konfidensiallıq
            Siyasəti Veb-saytda dərc edildiyi andan qüvvəyə minir.
          </P>
          <P>
            Bütün hallarda İstifadəçilərin fərdi məlumatlarının təhlükəsizliyi və
            konfidensiallığının qorunması Sparkle üçün əsas prinsiplərdən biri olaraq qalır.
          </P>
          <P>
            Bu Konfidensiallıq Siyasəti ilə bağlı hər hansı sualınız, iradınız, təklifiniz
            və ya şikayətiniz olarsa, Veb-saytda göstərilən əlaqə vasitələri ilə bizimlə
            əlaqə saxlaya bilərsiniz.
          </P>
        </div>
      </div>

      <div className="border-t border-brand-line mt-10 pt-6 flex flex-wrap gap-x-8 gap-y-2 text-sm">
        <a href="mailto:hello@sparkle.az" className="text-brand-ink hover:text-brand-sub">
          hello@sparkle.az
        </a>
        <a href="tel:+994558855522" className="text-brand-ink hover:text-brand-sub">
          +994 55 885 55 22
        </a>
      </div>
    </div>
  );
};

export default Privacy;
